module.exports = __webpack_public_path__ + "assets/fonts/Gotham-Black.80d5397d.otf";